<p-confirmDialog key="createVehicleArchive"></p-confirmDialog>

<form
  class="update-record-dialog"
  [formGroup]="vehicleForm"
  (ngSubmit)="onAddVehicleFormSubmit()"
>
  <section class="record-summary" aria-label="Vehicle context">
    <div class="record-summary__icon" aria-hidden="true">
      <i class="pi pi-truck"></i>
    </div>

    <div class="record-summary__copy">
      <span class="record-summary__eyebrow">{{ isInEditMode ? 'Edit Vehicle' : 'New Vehicle' }}</span>
      <h2>{{ vehicleForm.get('vehicle_reference')?.value || 'Vehicle details' }}</h2>
      <div class="record-summary__meta" *ngIf="isInEditMode">
        <span>Chassis: {{ vehicleForm.get('chassis_no')?.value || 'Not captured' }}</span>
        <span>Engine: {{ vehicleForm.get('engine_no')?.value || 'Not captured' }}</span>
      </div>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Vehicle details</h3>
    </div>

    <div class="form-grid">
      <div class="form-field form-field--wide">
        <label for="vehicleRef">Vehicle Reference</label>
        <input
          id="vehicleRef"
          formControlName="vehicle_reference"
          pInputText
          type="text"
          placeholder="Enter vehicle reference"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="vehicleForm.get('vehicle_reference')?.invalid && vehicleForm.get('vehicle_reference')?.touched"
        >
          <strong>Vehicle Reference</strong> is required
        </small>
      </div>

      <div class="form-field">
        <label for="vehicleModel">Vehicle Model</label>
        <input
          id="vehicleModel"
          formControlName="model"
          pInputText
          type="text"
          placeholder="Enter vehicle model"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="vehicleForm.get('model')?.invalid && vehicleForm.get('model')?.touched"
        >
          <strong>Vehicle Model</strong> is required
        </small>
      </div>

      <div class="form-field">
        <label for="chassisNo">Chassis Number</label>
        <input
          id="chassisNo"
          formControlName="chassis_no"
          pInputText
          type="text"
          placeholder="Enter chassis number"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="vehicleForm.get('chassis_no')?.invalid && vehicleForm.get('chassis_no')?.touched"
        >
          <strong>Chassis Number</strong> is required
        </small>
      </div>

      <div class="form-field">
        <label for="engineNo">Engine Number</label>
        <input
          id="engineNo"
          formControlName="engine_no"
          pInputText
          type="text"
          placeholder="Enter engine number"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="vehicleForm.get('engine_no')?.invalid && vehicleForm.get('engine_no')?.touched"
        >
          <strong>Engine Number</strong> is required
        </small>
      </div>

      <div class="form-field">
        <label for="yearModel">Year Model</label>
        <input
          id="yearModel"
          formControlName="year_model"
          pInputText
          type="text"
          placeholder="e.g. 2015"
          class="w-full"
        />
        <small
          class="p-error"
          *ngIf="vehicleForm.get('year_model')?.invalid && vehicleForm.get('year_model')?.touched"
        >
          <strong>Year Model</strong> is required and must be a 4-digit number e.g. 2015
        </small>
      </div>
    </div>
  </section>

  <section class="form-section">
    <div class="form-section__header">
      <h3>Service dates</h3>
    </div>

    <div class="form-grid">
      <div class="form-field">
        <label>Date in service</label>
        <p-calendar
          formControlName="date_inservice"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
        ></p-calendar>
        <small
          class="p-error"
          *ngIf="vehicleForm.get('date_inservice')?.invalid && vehicleForm.get('date_inservice')?.touched"
        >
          <strong>Date in service</strong> is required
        </small>
      </div>

      <div class="form-field">
        <label>Date out of service</label>
        <p-calendar
          formControlName="date_outservice"
          dateFormat="yy-mm-dd"
          dataType="string"
          [inline]="false"
          [touchUI]="true"
          appendTo="body"
          styleClass="w-full"
        ></p-calendar>
      </div>
    </div>
  </section>

  <div class="dialog-actions">
    <button
      pButton
      type="submit"
      [label]="submitButtonLabel"
      icon="pi pi-check"
      class="p-button-primary w-full"
      [loading]="loading"
    ></button>
  </div>
</form>
